import type { POI, Tag } from "@poi-planner/shared";

export function isAccommodationPoi(poi: POI, tags: Tag[]): boolean {
  const accommodationTagIds = new Set(
    tags
      .filter((tag) => tag.name.toLocaleLowerCase() === "accommodation")
      .map((tag) => tag.id),
  );
  return poi.tags.some((tag) => accommodationTagIds.has(tag));
}

export function filterAccommodationPois(pois: POI[], query: string): POI[] {
  const normalized = query.trim().toLocaleLowerCase();
  if (!normalized) return pois;
  return pois.filter((poi) =>
    poi.name.toLocaleLowerCase().includes(normalized),
  );
}
